export default __webpack_public_path__ + "static/media/DSC_0557.fceea93e.webp";